import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 3em;
  margin-top: 0;
  margin-bottom: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Test = styled.div``;
